import type { Chain } from "~/tools/chain";
import type { Defaultable } from "~/tools/defaultable";
import type { Functor } from "~/tools/functor";
import { Matchable } from "~/tools/matchable";

class Denied extends Matchable<"denied"> implements Functor<never>, Chain<never>, Defaultable<never> {
	protected readonly __name = "denied" as const;

	public isGranted(): false {
		return false;
	}

	public isDenied(): this is Denied {
		return true;
	}

	public getOrElse<TFallback>(fallback: TFallback): TFallback {
		return fallback;
	}

	public transform(): this {
		return this;
	}

	public chain(): this {
		return this;
	}
}

export { Denied };
